import { splitMatches } from "./searchTerms";

interface HighlightedTextProps {
    text: string;
    terms: string[];
    className?: string;
}

export function HighlightedText({
    text,
    terms,
    className,
}: HighlightedTextProps) {
    return (
        <span className={className}>
            {splitMatches(text, terms).map((segment, index) =>
                segment.match ? (
                    <mark
                        key={index}
                        className="bg-brand-copper/22 rounded-[2px] text-inherit"
                    >
                        {segment.text}
                    </mark>
                ) : (
                    segment.text
                )
            )}
        </span>
    );
}
